module.exports = __webpack_public_path__ + "media/newstyle/images/preco2-1a962e0a31f1cb9a2b361d955d4fbe74.png";